import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { organizersAPI } from '@/services/organizersApi';
import { queryKeys } from './queryKeys';

export function useOrganizers() {
  return useQuery({
    queryKey: queryKeys.organizers.all(),
    queryFn: () => organizersAPI.getOrganizers(),
  });
}

export function useOrganizer(id?: any) {
  return useQuery({
    queryKey: queryKeys.organizers.detail(id),
    queryFn: () => organizersAPI.getOrganizerById(id),
    enabled: !!id,
  });
}

export function useCreateOrganizer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => organizersAPI.createOrganizer(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.organizers._def }),
  });
}

export function useUpdateOrganizer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => organizersAPI.updateOrganizer(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.organizers._def }),
  });
}

export function useDeleteOrganizer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => organizersAPI.deleteOrganizer(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.organizers._def }),
  });
}
